/**
 * SEO 配置 - models (Русский)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - Флагманский генератор видео ИИ | WeryAI',
        description: 'Google Veo 3.1: Флагманская модель видео ИИ с нативным аудио и управлением кадрами.',
        keywords: 'Google Veo 3.1, видео ИИ, генератор видео, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 - Генерация видео ИИ высокого качества | WeryAI',
        description: 'Попробуйте Veo 3 на WeryAI. Высококачественные результаты.',
        keywords: 'Veo 3, Google Veo, видео ИИ, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast - Сверхбыстрая генерация видео ИИ | WeryAI',
        description: 'Попробуйте Veo 3 Fast на WeryAI. Быстрые и качественные результаты.',
        keywords: 'Veo 3 Fast, быстрое видео ИИ, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - Реалистичный генератор видео ИИ | WeryAI',
        description: 'Попробуйте Sora 2 на WeryAI. Высококачественные результаты.',
        keywords: 'Sora 2, OpenAI Sora, видео ИИ, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - Генератор видео ИИ | WeryAI',
        description: 'Попробуйте WeryAI Video 1.0 для создания кинематографических видео ИИ.',
        keywords: 'WeryAI Video 1.0, видео ИИ, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 - Генератор изображений ИИ | WeryAI',
        description: 'Попробуйте WeryAI Image 2.0 для генерации изображений студийного качества.',
        keywords: 'WeryAI Image 2.0, изображения ИИ, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 Генератор изображений - xAI | WeryAI',
        description: 'Попробуйте Grok-2 от xAI на WeryAI.',
        keywords: 'Grok-2, xAI, изображения ИИ, WeryAI',
    },
    kling_ai: {
        title: 'Kling AI - Кинематографический генератор видео ИИ | WeryAI',
        description: 'Попробуйте Kling AI на WeryAI. Высококачественные результаты.',
        keywords: 'Kling AI, видео ИИ, WeryAI',
    },
    runway_ai: {
        title: 'Runway AI - Генератор и редактор видео ИИ | WeryAI',
        description: 'Попробуйте Runway AI на WeryAI. Высококачественные результаты.',
        keywords: 'Runway AI, видео ИИ, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 - Генератор видео ИИ | WeryAI',
        description: 'Попробуйте Hailuo 2.3 на WeryAI. Высококачественные результаты.',
        keywords: 'Hailuo 2.3, видео ИИ, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI - Продвинутый генератор видео ИИ | WeryAI',
        description: 'Попробуйте Hailuo AI на WeryAI. Высококачественные результаты.',
        keywords: 'Hailuo AI, видео ИИ, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - Генератор анимации ИИ | WeryAI',
        description: 'Попробуйте Pika 2.2 на WeryAI. Высококачественные результаты.',
        keywords: 'Pika 2.2, анимация ИИ, WeryAI',
    },
    seedance: {
        title: 'Seedance - Генератор видео танцев и движений ИИ | WeryAI',
        description: 'Попробуйте Seedance на WeryAI. Реалистичные и профессиональные результаты.',
        keywords: 'Seedance, видео ИИ, WeryAI',
    },
    wan_ai: '',
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - Генерация изображений Google Gemini 3.0 Pro | WeryAI',
        description: 'Модель изображений ИИ на основе рассуждений. Качество 4K сверхреалистичное и идеальная типографика.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, генерация изображений ИИ, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Сверхбыстрое рисование Gemini 2.5 Flash | WeryAI',
        description: 'Сверхбыстрый генератор изображений ИИ от Google DeepMind. Поддержка редактирования на естественном языке.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, быстрое рисование, WeryAI',
    },
    image_flux: {
        title: 'FLUX AI Генератор изображений - Открытая модель | WeryAI',
        description: 'FLUX разработан командой Stable Diffusion. Исключительное визуальное качество.',
        keywords: 'FLUX, ИИ, генерация изображений, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - Профессиональное улучшение рисования ИИ | WeryAI',
        description: 'FLUX.1 Pro и Max с улучшенным рендерингом текста и согласованностью персонажей.',
        keywords: 'FLUX Kontext, FLUX Pro, FLUX Max, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - Диффузионная модель текст-в-изображение | WeryAI',
        description: 'Создавайте фотореалистичные, художественные и абстрактные изображения с Google Imagen 4.',
        keywords: 'Imagen 4, Google AI, диффузия, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - Модель рендеринга текста Alibaba | WeryAI',
        description: 'Модель изображений ИИ от Alibaba для многоязычного рендеринга текста.',
        keywords: 'Qwen Image, Alibaba, рендеринг текста, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 Генерация изображений - Высококачественная модель Alibaba | WeryAI',
        description: 'Wan 2.5 с точным следованием подсказкам и фотографическим рендерингом.',
        keywords: 'Wan AI, Wan 2.5, генерация изображений, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - Модель пакетного рисования 4K от ByteDance | WeryAI',
        description: 'Сверхбыстрая модель рисования от ByteDance с пакетной обработкой.',
        keywords: 'Seedream, ByteDance, рисование 4K, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - Модель создания изображений ИИ от ByteDance | WeryAI',
        description: 'Dreamina 4.0 для преобразования эскизов в изображения и переноса стилей.',
        keywords: 'Dreamina 4.0, ByteDance, создание изображений ИИ, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - Флагманская модель генерации изображений ИИ от ByteDance | WeryAI',
        description: 'Seedream 4.5 — новейшая флагманская модель изображений ИИ от ByteDance с точным рендерингом типографики и объединением изображений с выводом 4K Ultra HD. Попробуйте бесплатно на WeryAI.',
        keywords: 'Seedream 4.5, генерация изображений ИИ, рендеринг типографики, объединение изображений, ByteDance, качество 4K, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - Гибкая, детализированная и яркая генерация изображений | WeryAI',
        description: 'Midjourney — это флагманская модель изображений ИИ от независимой исследовательской лаборатории, известная своей художественной эстетикой. Попробуйте бесплатно на WeryAI.',
        keywords: 'Midjourney, генерация изображений ИИ, художественное творчество, качество освещения, рендеринг текста, гиперреалистичные портреты, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Генератор видео ИИ - Создавайте кинематографические видео | WeryAI',
        description: 'Создавайте потрясающие видео с Runway Gen-4.5 на WeryAI. Гибридная авторегрессивно-диффузионная архитектура для точной физической симуляции и временной согласованности.',
        keywords: 'Runway Gen-4.5, генератор видео ИИ, кинематографическое видео ИИ, физическая симуляция, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Генератор видео ИИ - Высококачественное создание видео | WeryAI',
        description: 'Создавайте высококачественные видео с Kling 2.6 Pro на WeryAI. Нативная аудиовизуальная генерация, кинематографическое качество 1080p, превосходное следование подсказкам.',
        keywords: 'Kling 2.6 Pro, генератор видео ИИ, высококачественное видео ИИ, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Генератор видео - Точный контроль камеры и направление кадров | WeryAI',
        description: 'Создавайте кинематографические видео ИИ с Dreamina 3.0 (Jimeng 3.0) на WeryAI. Точный контроль начальных/конечных кадров, профессиональные движения камеры и генерация видео 1080p высокой динамики.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, генератор видео ИИ, контроль камеры, начальные конечные кадры, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Генератор видео ИИ - Креативная генерация видео | WeryAI',
        description: 'Раскройте свой творческий потенциал на WeryAI с генератором видео ИИ Kling O1. Идеально для создания воображаемого и уникального видеоконтента.',
        keywords: 'Kling O1, генератор видео ИИ, креативное видео ИИ, Kling AI, WeryAI',
    },
}
